import { storeToRefs } from 'pinia'
import { useUserStore } from '~/pinia/userStore'
import { useQueueStore } from '~/pinia/queueStore'

export function useExplicit() {
	const userStore = useUserStore()
	const queueStore = useQueueStore()
	const { explicitContent } = storeToRefs(userStore)
	const { firstInQueue } = storeToRefs(queueStore)
	const { $oruga } = useNuxtApp()

	/**
   * Checks if the current song is explicit and if the user has explicit content disabled
   * @param {boolean} skipSong - Whether to skip the song if it's explicit
   * @returns {boolean} - True if song should be skipped, false otherwise
   */
	const skipExplicitContent = (skipSong = true) => {
		if (!explicitContent.value && firstInQueue.value?.entry?.has_explicit) {
			if (skipSong) {
				const { $i18n } = useNuxtApp()
				const { t } = $i18n
				queueStore.nextSong()
				$oruga.notification.open({ message: t('player.notifications.skippingExplicitSong'), variant: 'warning' })
			}
			return true
		}
		return false
	}

	return {
		skipExplicitContent
	}
}
